export function MiniBars({ items, testId = 'mini-bars' }) {
  const max = Math.max(1, ...items.map(i => i.count));
  return (
    <div className="space-y-1.5" data-testid={testId}>
      {items.map(i => (
        <div key={i.label} className="flex items-center gap-2 text-[12px]">
          <span className="w-[130px] truncate text-[hsl(var(--foreground-muted))]" title={i.label}>{i.label}</span>
          <div className="flex-1 h-2 rounded-full" style={{ background: 'hsl(var(--surface-2))' }}>
            <div className="h-2 rounded-full transition-all"
                 style={{ width: `${(i.count / max) * 100}%`, background: i.color || 'hsl(var(--primary))' }} />
          </div>
          <span className="w-7 text-right tabular-nums font-medium">{i.count}</span>
        </div>
      ))}
      {items.length === 0 && (
        <div className="text-[12px] italic text-[hsl(var(--foreground-subtle))]">No data yet.</div>
      )}
    </div>
  );
}
